import {
  createDefaultNativeStackNavigator,
  createModalScreenOptions,
  createWebModalScreenOptions,
} from 'app/lib/navigation';
import { ChooseScreen } from './choose';
import { ConfirmScreen } from './confirm';
import { ThanksScreen } from './thanks';
import type { PopularItem } from 'app/types/category';

import { useUISize } from 'app/utils/web-helpers';
import type { ComponentProps } from 'react';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export type Parameters = {
  'quick-new-choose': undefined;
  'quick-new-confirm': { selectedItems: PopularItem[]; fromBabillard?: boolean };
  'quick-new-thanks': { userNowContributor: boolean; listingIds?: string[]; fromBabillard?: boolean } | undefined;
};

export { linking } from './navigator.linking';

const Stack = createDefaultNativeStackNavigator<Parameters>({
  withChat: false,
  withInvite: false,
});

export function Navigator() {
  const { isSmallUI } = useUISize();
  return (
    <Stack.Navigator initialRouteName="quick-new-choose">
      <Stack.Screen
        component={ChooseScreen}
        name="quick-new-choose"
        options={({ navigation, route }) => {
          if (!isSmallUI) {
            return createWebModalScreenOptions(navigation, route) as ComponentProps<typeof Stack.Navigator>;
          }
          return createModalScreenOptions(navigation, route);
        }}
        // options={({ navigation, route }) => createModalScreenOptions(navigation, route)}
      />
      <Stack.Screen
        component={ConfirmScreen}
        name="quick-new-confirm"
        options={({ navigation, route }) => {
          if (!isSmallUI) {
            return createWebModalScreenOptions(navigation, route) as ComponentProps<typeof Stack.Navigator>;
          }
          return {
            headerShown: true,
            headerShadowVisible: false,
            headerStyle: { backgroundColor: theme.colors['surface.default'] },
            headerTitleStyle: { color: theme.colors['text.primary'] },
            headerTintColor: theme.colors['text.primary'], // Color for back arrow (left)
          };
        }}
      />
      <Stack.Screen
        component={ThanksScreen}
        name="quick-new-thanks"
        options={({ navigation, route }) => {
          if (!isSmallUI) {
            return createWebModalScreenOptions(navigation, route, true) as ComponentProps<typeof Stack.Navigator>;
          }
          return createModalScreenOptions(navigation, route, true);
        }}
      />
    </Stack.Navigator>
  );
}
